// JUST TO HANDLE REDUX LOGIC, DISPATCHES ACTIONS, ACCESSES GLOBAL STATE
// IMPORTANT	--DO NOT DO CALLS TO (API)-- PLEASE USE SERVICE FILE

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getDailyTickets,
  getDailyTicketsByPeriod,
  updateDailyTicketNote,
  getDailyTicketByDate,
  updateDailyTicketNotes
} from './dailyTicketsService';

export const fetchDailyTickets = createAsyncThunk('dailyTickets/fetchDailyTickets', async (vid) => {
  // Get the Daily Tickets from Firestore without a period
  const dailyTickets = await getDailyTickets(vid);
  return dailyTickets;
});

export const fetchDailyTicketByDate = createAsyncThunk(
  'dailyTickets/fetchDailyTicketByDate',
  async ({ vid, dateString }) => {
    // Get the Daily Ticket from Firestore for a specific date
    const dailyTicket = await getDailyTicketByDate(vid, dateString);
    return dailyTicket;
  }
);

export const fetchDailyTicketsByPeriod = createAsyncThunk(
  'dailyTickets/fetchDailyTicketsByPeriod',
  async ({ vid, selectedWeek }) => {
    // Get the Daily Tickets from Firestore
    const dailyTickets = await getDailyTicketsByPeriod(vid, selectedWeek);
    return dailyTickets;
  }
);

export const updateDailyTicket = createAsyncThunk(
  'dailyTickets/updateDailyTicketNote',
  async ({ ticketId, fieldName, noteText, vid }) => {
    // Update the note
    await updateDailyTicketNote(ticketId, fieldName, noteText);

    // Fetch updated tickets
    const updatedTickets = await getDailyTickets(vid);
    return updatedTickets;
  }
);

export const updateDailyTicketNotesThunk = createAsyncThunk(
  'dailyTickets/updateDailyTicketNotes',
  async ({ vid, dateString, noteType, noteText }) => {
    const updatedTicket = await updateDailyTicketNotes(vid, dateString, noteType, noteText);
    return updatedTicket;
  }
);
